import * as React from 'react';
import {
    Text,
    styled,
    TokenTextColor,
    TokenTextAppearance
} from '@volkswagen-onehub/components-core';
import {makeClip} from '../helpers';

const StyledPricesWrapper = styled.div`
    display: flex;
    flex-flow: column;
`;

const StyledOldPrice = styled(Text)`
    text-decoration: line-through;
    color: ${props => props.theme.colors.content.tertiary};
`;

const StyledDiscountPrice = styled(Text)`
    color: ${props => props.theme.colors.content.tertiary};
`;

const StyledHiddenText = styled.span`
    ${makeClip}
`;

export interface CampaignPricesProps {
    readonly oldPrice?: string;
    readonly newPrice?: string;
    readonly leasingPrice?: string;
    readonly discountPrice?: string;
    readonly oldPriceLabel?: string;
    readonly newPriceLabel?: string;
    readonly leasingPriceLabel?: string;
}

export function CampaignPrices(props: CampaignPricesProps): JSX.Element {
    const {
        oldPrice,
        newPrice,
        leasingPrice,
        discountPrice,
        oldPriceLabel,
        newPriceLabel,
        leasingPriceLabel
    } = props;

    const hasPrices = Boolean(
        oldPrice || newPrice || leasingPrice || discountPrice
    );

    return (
        <>
            {hasPrices && (
                <StyledPricesWrapper>
                    {leasingPrice && (
                        <Text
                            color={TokenTextColor.inherit}
                            appearance={TokenTextAppearance.bigcopy100}
                            bold
                        >
                            <StyledHiddenText>
                                {leasingPriceLabel}:
                            </StyledHiddenText>
                            {leasingPrice}
                        </Text>
                    )}
                    {newPrice && (
                        <Text
                            color={TokenTextColor.inherit}
                            appearance={TokenTextAppearance.headline300}
                            bold
                        >
                            <StyledHiddenText>
                                {newPriceLabel}:
                            </StyledHiddenText>
                            {newPrice}
                        </Text>
                    )}
                    {oldPrice && (
                        <StyledOldPrice
                            color={TokenTextColor.inherit}
                            appearance={TokenTextAppearance.copy200}
                        >
                            <StyledHiddenText>
                                {oldPriceLabel}:
                            </StyledHiddenText>
                            {oldPrice}
                        </StyledOldPrice>
                    )}
                    {discountPrice && (
                        <StyledDiscountPrice
                            color={TokenTextColor.inherit}
                            appearance={TokenTextAppearance.copy200}
                        >
                            {discountPrice}
                        </StyledDiscountPrice>
                    )}
                </StyledPricesWrapper>
            )}
        </>
    );
}
